import React from 'react';
import styles from '../CaseIntelligenceVibrantPage.module.scss';

interface Props {
  value: number;
  percent: number;
  score: string;
  label: string;
}

function getConfidenceRingTheme(score: number) {
  if (score >= 0.9) {
    return {
      active: '#166534',
      label: '#166534',
      track: 'color-mix(in srgb, #16a34a 16%, transparent)',
    };
  }

  if (score >= 0.7) {
    return {
      active: '#16a34a',
      label: '#166534',
      track: 'color-mix(in srgb, #16a34a 14%, transparent)',
    };
  }

  if (score >= 0.5) {
    return {
      active: '#f59e0b',
      label: '#f59e0b',
      track: 'color-mix(in srgb, #f59e0b 18%, transparent)',
    };
  }

  return {
    active: '#f97316',
    label: '#f97316',
    track: 'color-mix(in srgb, #f97316 18%, transparent)',
  };
}

const ConfidenceRing: React.FC<Props> = ({ value, percent, score, label }) => {
  const theme = getConfidenceRingTheme(value);
  const panelStyle = {
    '--confidence-fill': `${percent}%`,
    '--confidence-active': theme.active,
    '--confidence-track': theme.track,
    '--confidence-label': theme.label,
  } as React.CSSProperties;

  return (
    <div className={styles.confidencePanel} style={panelStyle}>
      <div className={styles.confidenceRing} aria-label={`${label}: ${score}`}>
        <div className={styles.confidenceRingInner}>
          <div className={styles.confidenceRingValue}>
            <span className={styles.confidenceRingScore}>{score}</span>
          </div>
        </div>
      </div>
      <div className={styles.confidenceRingLabel}>{label}</div>
    </div>
  );
};

export default ConfidenceRing;
